// extracted by mini-css-extract-plugin
export default {"top":"HeaderShift_top__DJwZG","box":"HeaderShift_box__D+cc+","addButton":"HeaderShift_addButton__cnImg"};